import { InstructorAssignmentCard, Text } from 'shell/components';

const assignment1 = {
    id: '1',
    title: 'Assignment Name',
    ai_feedback_enabled: false,
    ai_grading_enabled: true,
};

const assignment2 = {
    id: '1',
    title: 'Assignment Name',
    ai_feedback_enabled: true,
    ai_grading_enabled: true,
};

const InstructorAssignmentCardDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>InstructorAssignmentCard</Text>
            <InstructorAssignmentCard sx={{ width: '500px' }} assignment={assignment1} onClick={console.log} />
            <InstructorAssignmentCard sx={{ width: '500px' }} assignment={assignment2} onClick={console.log} />
        </>
    );
};

export default InstructorAssignmentCardDemo;
